;(function() {

	function AttachmentsPreview(elements) {
		this.elements = elements;
		this.imageObject = null;
		this.isImageLoaded = false;

		this.placeholders = [];
		this.progresses = [];
		for (let i = 0; i < this.elements.length; ++i) {
			let element = this.elements[i];
			let placeholder = element.querySelector(".placeholder");
			if (!placeholder) {
				placeholder = document.createElement("div");
				placeholder.classList.add("placeholder");
				element.append(placeholder);
			}
			this.placeholders.push(placeholder);

			let progress = element.querySelector(".progress");
			if (!progress) {
				progress = document.createElement("div");
				progress.classList.add("progress");
				element.append(progress);
			}
			this.progresses.push(progress);

			element.classList.add("form-attachments-preview", "sending-request");
		}
	}
	AttachmentsPreview.prototype = {
		constructor: AttachmentsPreview,

		set image(image) {
			this.imageObject = image;

			for (let i = 0; i < this.placeholders.length; ++i) {
				this.placeholders[i].style.paddingTop = (this.imageObject.height / this.imageObject.width * 100.0) + "%";
			}

			if (this.isImageLoaded) {
				this.showImage();
			}
		},

		showProgress: function(percent) {
			for (let i = 0; i < this.progresses.length; ++i) {
				this.progresses[i].innerText = (percent !== false) ? percent + "%" : "";
			}
		},

		showImage: function() {
			this.isImageLoaded = true;

			for (let i = 0; i < this.elements.length; ++i) {
				this.elements[i].classList.remove("sending-request");
			}

			if (this.imageObject) {
				this.showProgress(false);
				for (let i = 0; i < this.placeholders.length; ++i) {
					this.placeholders[i].outerHTML = "<img src='" + this.imageObject.src + "' width='" + this.imageObject.width + "' height='" + this.imageObject.height + "' alt=''>";
				}
			}
		}
	};


	function AttachmentsContainer(wrapper) {
		this.wrapper = wrapper;
		this.inputs = wrapper.querySelectorAll("input, textarea, select, button");
		this.preview = new AttachmentsPreview(wrapper.querySelectorAll(".form-attachments-preview"));
	}
	AttachmentsContainer.prototype = {
		constructor: AttachmentsContainer,

		set disabled(state) {
			for (let i = 0; i < this.inputs.length; ++i) {
				this.inputs[i].disabled = state;
			}
		},
	};

	function FileUploader(url, fieldName, file, extraData) {
		this.url = url;
		this.fieldName = fieldName;
		this.file = file;
		this.extraData = extraData || {};
	}
	FileUploader.prototype = {
		constructor: FileUploader,

		upload: function() {
			let self = this;
			let formData = new FormData();

			formData.append(this.fieldName, this.file);

			if (this.extraData) {
				for (let key in this.extraData) {
					if (this.extraData[key] !== null) {
						formData.append(key, this.extraData[key]);
					}
				}
			}

			let xhr = new XMLHttpRequest();
			// xhr.upload.onerror = function() {
			// 	console.log("CHYBA")
			// }
			// xhr.upload.onabort = function() {
			// 	console.log("ABORT")
			// }
			xhr.upload.onprogress = function(event) {
				if (event.lengthComputable) {
					let percentComplete = (event.loaded / event.total) * 100.0;
					self.onProgress(percentComplete);
				}
			}
			xhr.onload = function(event) {
				// console.log(xhr.status);
				// console.log(xhr.response);
				// preview.showImage();
				self.onSuccess(JSON.parse(xhr.response));
			}

			xhr.open("POST", this.url);
			xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
			xhr.setRequestHeader("X-CSRF-Token", this.getCsrfToken());

			xhr.send(formData);
		},

		getCsrfToken: function() {
			return document.head.querySelector("meta[name='csrf-token']").getAttribute("content");
		},

		onProgress: function(percent) {
			if (this.onprogress) {
				this.onprogress(percent);
			}
		},

		onSuccess: function(data) {
			if (this.onsuccess) {
				this.onsuccess(data);
			}
		}

	}

	function readImageFile(file, options) {
		options = options || {};


		return new Promise(function(resolve, reject) {
			function validateImage(image) {
				if (options.landscape) {
					if (image.height <= image.width) {
						resolve(image);
					}
					else {
						reject({ image: image, error: "Fotografie nemá formát na šířku. Otočte fotoaparát a vyfoťte objekt znovu." });
					}
				}
				else {
					resolve(image);
				}
			}

			let fileReader = new FileReader();

			fileReader.onload = function(event) {
				let image = new Image();
				image.onload = function() {
					validateImage(image);
				}
				image.src = event.target.result;
			}

			fileReader.readAsDataURL(file);
		});
	}

	document.addEventSelectorListener("change", ".form-attachments input[type='file'][data-upload]", function(event, target) {
		if (!target.files) {
			return;
		}

		for (let i = 0; i < target.files.length; ++i) {
			let file = target.files[i];
			let objectClass = target.getAttribute("data-object-class");
			let associationPath = target.getAttribute("data-association-path");
			let scope = ".form-attachments[data-kind='" + target.getAttribute("data-kind") + "']";
			let isOnlyLandscape = !!target.closest(".form-attachments").getAttribute("data-landscape");

			readImageFile(file, { landscape: isOnlyLandscape })
				.then(function (image) {
					let nestedContainer = NestedFormFields.add(objectClass, associationPath, scope);
					let container = new AttachmentsContainer(nestedContainer);
					let fileUploader = new FileUploader(target.getAttribute("data-upload"), target.getAttribute("name"), file, target.getAttribute("data-upload-data") ? JSON.parse(target.getAttribute("data-upload-data")) : {});

					container.disabled = true;
					container.preview.image = image;

					fileUploader.onprogress = function (percent) {
						container.preview.showProgress(Math.round(percent));
					}
					fileUploader.onsuccess = function (data) {
						container.disabled = false;
						container.preview.showImage();

						let inputName = container.wrapper.querySelector("[data-delete-association-field-name]").getAttribute("data-delete-association-field-name").replace("[_destroy]", "[id]");

						let element = document.createElement("input");
						element.setAttribute("type", "hidden");
						element.setAttribute("name", inputName);
						element.value = data.id;
						container.wrapper.append(element);

						let titleInput = nestedContainer.querySelector("input[name$='[title]']");
						if (titleInput && data.title) {
							titleInput.value = data.title;
						}

						container.wrapper.trigger("input");
					}

					fileUploader.upload();
				})
				.catch(function (data) {
					console.log(data);
					ModalAlert.error(data.error);
				});
		}

		// Clear form field (prevent duplicate uploads)
		target.value = null;
	});

}());
